import { cva } from 'class-variance-authority';

/*
 * Safe-area insets (APPS-6514 follow-up).
 *
 * A native <dialog> renders in the top layer and is positioned against the viewport, so it is
 * unreachable from any ancestor's padding — the Drawer and bottom-sheet padding elsewhere in the
 * app does not cover it. Under `viewport-fit=cover` a variant pinned to a screen edge therefore
 * runs under the iOS home indicator and the app's translucent tab bar.
 *
 * The inset goes on the <dialog> itself because it is also the painted panel
 * (`bg-color-background-base`), so the background stays flush to the screen edge while the content
 * clears it. Each variant only pads the edges it actually touches; the tokens resolve to 0px off
 * iOS, so nothing changes on Android or in a browser.
 */
const drawerClasses =
  'c_drawer-dialog md:inset-[0_0_0_auto] md:max-w-[50dvw] md:min-w-[25dvw] md:rounded-l-md md:pt-safe-t md:pb-safe-b';
const bottomSheetClasses =
  'c_bottom-sheet-dialog max-md:inset-[auto_0_0_0] max-md:h-auto max-md:max-h-[85dvh] max-md:min-h-[35dvh] max-md:rounded-t-md max-md:pb-safe-b';
export const dialogVariants = cva(
  'backdrop:bg-color-backdrop bg-color-background-base m-0 max-w-[900px] min-w-full flex-col',
  {
    variants: {
      variant: {
        default: 'pt-safe-t pb-safe-b min-h-full',
        bottomSheet: bottomSheetClasses,
        drawer: `${drawerClasses} max-md:pt-safe-t max-md:pb-safe-b max-md:min-h-full`,
        drawerBottomSheet: `${bottomSheetClasses} ${drawerClasses} c_dialog-exit-animation`,
      },
      isOpen: { true: 'flex md:m-auto md:min-w-0' },
    },
    defaultVariants: {
      variant: 'default',
    },
    compoundVariants: [
      {
        variant: ['drawer', 'drawerBottomSheet'],
        isOpen: true,
        className: 'md:h-[100dvh] md:min-h-[100dvh]',
      },
      {
        variant: ['default', 'bottomSheet'],
        isOpen: true,
        className: 'md:h-fit md:min-h-0',
      },
    ],
  },
);
